var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.654,
    height: 29.654,
    viewBox: "100.215 181.173 14.827 14.827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-grid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.215 181.173h5.766v5.766h-5.766v-5.766Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#c1c1c1",
    fill: "transparent",
    "data-name": "Trac\\xE9 830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.276 181.173h5.766v5.766h-5.766v-5.766Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#c1c1c1",
    fill: "transparent",
    "data-name": "Trac\\xE9 831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.276 190.234h5.766V196h-5.766v-5.766Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#c1c1c1",
    fill: "transparent",
    "data-name": "Trac\\xE9 832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.215 190.234h5.766V196h-5.766v-5.766Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#c1c1c1",
    fill: "transparent",
    "data-name": "Trac\\xE9 833"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.8d78b09e2aa046007405c54790182596.svg";
export { ForwardRef as ReactComponent };